import { CanvasData } from "@/services/apitypes";
import { StyledMarkdown } from "@/ui/components/StyledMarkdown";
import {
  accentDividerStyle,
  darkSurfaceDisclosureControlClassName,
  darkSurfaceDisclosureStyles,
} from "@canucci/base-mantine/theme";
import { Accordion, Box, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

interface InsightsCanvasSummaryProps {
  canvasData: CanvasData;
  inverted?: boolean;
}

export default function InsightsCanvasSummary({ canvasData, inverted = false }: InsightsCanvasSummaryProps) {
  const { t } = useTranslation("pages");

  const headerText = canvasData.text?.summary;
  const intro = canvasData.text?.body;

  if (!headerText && !intro) return null;

  const textColor = inverted ? "var(--text-on-dark)" : undefined;

  return (
    <Box w="100%">
      <Accordion defaultValue={undefined} variant="default" styles={darkSurfaceDisclosureStyles}>
        <Accordion.Item value="info">
          <Accordion.Control c={textColor} py={4} px="xs" ml="-xs" className={darkSurfaceDisclosureControlClassName}>
            <Stack gap={0} align="flex-start">
              <Title size="h4" ta="left" c={textColor}>
                {t("canvas.insights.aboutThisCanvas", "About this canvas")}
              </Title>
              <Box mt="xs" style={accentDividerStyle} />
            </Stack>
          </Accordion.Control>
          <Accordion.Panel>
            <Box c={textColor}>
              {headerText && (
                <Title order={3} size="h5" fw="normal" mb="md" lh={1.5} c="var(--text-on-dark-muted)">
                  {headerText}
                </Title>
              )}
              {intro && <StyledMarkdown content={intro} paragraphTextProps={{ c: "var(--text-on-dark-muted)" }} />}
            </Box>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Box>
  );
}
